import type { ShopModuleKey } from '~/utils/shopModules'

export interface PlatformPublicAddon {
  key: ShopModuleKey
  label: string
  description: string
  monthlyAmount: number
  yearlyAmount: number
  setupAmount?: number
}

export interface PlatformPublicPlans {
  currency: string
  trialDays: number
  monthlyAmount: number
  yearlyAmount: number
  signupEnabled: boolean
  addons?: PlatformPublicAddon[]
}

export function usePlatformPlans() {
  const config = useRuntimeConfig()
  const plans = useState<PlatformPublicPlans | null>('platform-public-plans', () => null)
  const loading = useState('platform-public-plans-loading', () => false)
  const error = useState('platform-public-plans-error', () => '')

  async function fetchPlans() {
    if (plans.value) return plans.value
    loading.value = true
    error.value = ''
    try {
      const res = await $fetch<{ success?: boolean, data?: PlatformPublicPlans }>(
        `${String(config.public.platformApiUrl).replace(/\/$/, '')}/public/plans`,
      )
      if (res.data) {
        plans.value = res.data
        return res.data
      }
    } catch {
      error.value = 'Nu am putut încărca prețurile'
    } finally {
      loading.value = false
    }
    return plans.value
  }

  function formatMoney(amount: number, currency = plans.value?.currency || 'RON') {
    return new Intl.NumberFormat('ro-RO', {
      style: 'currency',
      currency,
      maximumFractionDigits: amount % 1 === 0 ? 0 : 2,
    }).format(amount)
  }

  return { plans, loading, error, fetchPlans, formatMoney }
}
